import React, { FC, memo } from "react";
import { ISvG } from "~/types/SvGTypes";

const Icon: FC<ISvG> = ({ fill = "#FFF" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19.25"
      height="22"
      viewBox="0 0 19.25 22"
    >
      <g id="svg" transform="translate(-565 -294)">
        <g id="file-extension" transform="translate(565 294)">
          <path
            id="Контур_725"
            data-name="Контур 725"
            d="M20.7,0H32.387l6.192,6.168V20.625A1.375,1.375,0,0,1,37.2,22H20.7a1.375,1.375,0,0,1-1.375-1.375V1.375A1.375,1.375,0,0,1,20.7,0Z"
            transform="translate(-19.329)"
            fill="#d39349"
          />
          <path
            id="Контур_726"
            data-name="Контур 726"
            d="M209.125,6.367h-4.793a1.375,1.375,0,0,1-1.375-1.375V.193Z"
            transform="translate(-189.894 -0.179)"
            fill="#774f1f"
          />
        </g>
        <path
          id="Контур_820"
          data-name="Контур 820"
          d="M2.317-1.415a.385.385,0,0,0-.146-.321,1.81,1.81,0,0,0-.512-.238,4.909,4.909,0,0,1-.6-.238A1.133,1.133,0,0,1,.305-3.232.915.915,0,0,1,.493-3.8a1.218,1.218,0,0,1,.533-.385A2.074,2.074,0,0,1,1.8-4.324a1.815,1.815,0,0,1,.752.15,1.191,1.191,0,0,1,.517.426,1.113,1.113,0,0,1,.184.632H2.32a.47.47,0,0,0-.146-.369.568.568,0,0,0-.394-.131.64.64,0,0,0-.4.111.34.34,0,0,0-.146.282.343.343,0,0,0,.16.271,2.022,2.022,0,0,0,.564.251,3.454,3.454,0,0,1,.663.279,1.114,1.114,0,0,1,.631,1,.95.95,0,0,1-.385.8,1.711,1.711,0,0,1-1.055.291A2.094,2.094,0,0,1,.958-.5,1.291,1.291,0,0,1,.381-.962a1.211,1.211,0,0,1-.194-.68h.941a.6.6,0,0,0,.162.461.764.764,0,0,0,.525.148.6.6,0,0,0,.367-.1A.331.331,0,0,0,2.317-1.415ZM5.3-1.439l.775-2.832H7.123L5.813-.381H4.787l-1.3-3.89H4.528Zm5.345.577a1.508,1.508,0,0,1-.633.387A2.731,2.731,0,0,1,9.1-.327,1.629,1.629,0,0,1,7.877-.795a1.893,1.893,0,0,1-.489-1.3l0-.337a2.322,2.322,0,0,1,.2-1A1.508,1.508,0,0,1,8.17-4.1a1.644,1.644,0,0,1,.875-.231,1.723,1.723,0,0,1,1.129.333A1.41,1.41,0,0,1,10.643-3h-.9a.738.738,0,0,0-.208-.465.672.672,0,0,0-.454-.139.612.612,0,0,0-.545.3,1.6,1.6,0,0,0-.2.855v.235a1.564,1.564,0,0,0,.2.875.7.7,0,0,0,.627.293.788.788,0,0,0,.545-.163v-.6H9.056v-.644h1.59Z"
          transform="translate(568.901 309)"
          fill="#fff"
        />
      </g>
    </svg>
  );
};

export default memo(Icon);
